<template>
  <div class="flex flex-1 flex-col">
    <vx-card title="Нормативы" class="vx-card_full-height">
      <div slot="actions" class="flex flex-no-wrap items-center">
        <vs-button
          class="mr-2 mb-2"
          type="border"
          @click="onShowCreate"
          iconPack="feather"
          icon="icon-plus"
          title="Добавить"
          v-if="$can('rp.tariffs', 'write')"
        />
      </div>

      <grid-infinite-scroll
        ref="table"
        :columns="regulationsColumns"
        :getData="updateData"
        :filterable="false"
        :sortable="false"
        no-rows-text="Нормативов нет"
        :page-size="100000"
      />

      <!--      <ag-grid-table :getData="updateData"-->
      <!--                     :columns="regulationsColumns"-->
      <!--                     :breakpoint="600"-->
      <!--                     no-rows-text="Нормативов нет"-->
      <!--                     ref="table"-->
      <!--                     @selectionChanged="rowSelected"-->
      <!--      />-->
    </vx-card>
  </div>
</template>

<script>
import RegulationActions from "@/components/calculated-program/regulations/RegulationActions";

export default {
  name: "Regulations",
  data() {
    return {
      regulationsColumns: [
        {
          headerName: 'Тип прибора',
          field:      'device_type',
          // filter:      true,
          valueGetter: ( { data } ) => this.$store.getters['common/devices/typeById'](data.device_type).name,
        },
        {
          headerName: 'Действует с',
          field:      'start_date',
          // filter:      true,
          valueGetter: ( { data } ) => {
            return data.start_date ? this.$options.filters.moment(this.$parseDateFromString(data.start_date)) : '-';
          },
        },
        {
          headerName: 'Действует по',
          field:      'end_date',
          // filter:      true,
          valueGetter: ( { data } ) => {
            return data.end_date ? this.$options.filters.moment(this.$parseDateFromString(data.end_date)) : '-';
          },
        },
        {
          headerName: 'Тип значения',
          field:      'calculated',
          // filter:      true,
          valueGetter: ( { data } ) => data.calculated === true ? 'Удельное' : 'Норматив',
        },
        {
          headerName: 'Количество комнат',
          field:      'rooms',
          // filter:      true,
          valueGetter: ( { data } ) => data.rooms ? data.rooms : '-',
        },
        {
          headerName: 'Количество проживающих',
          field:      'living',
          // filter:      true,
          valueGetter: ( { data } ) => data.living ? data.living : '-',
        },
        {
          headerName: 'Значение',
          field:      'value',
          // filter:      true,
          valueGetter: ( { data } ) => data.value ? data.value : '-',
        },
        {
          headerName: 'Значение для электрической плиты',
          field:      'value_elect_oven',
          // filter:      true,
          valueGetter: ( { data } ) => data.value_elect_oven ? data.value_elect_oven : '-',
        },
        {
          headerName: 'Значение для газовой плиты',
          field:      'value_gas_oven',
          // filter:      true,
          valueGetter: ( { data } ) => data.value_gas_oven ? data.value_gas_oven : '-',
        },
        {
          headerName:            '',
          field:                 'actions',
          filter:                false,
          sort:                  false,
          minWidth:              80,
          maxWidth:              80,
          cellRendererFramework: RegulationActions,
          cellRendererParams:    params => {
            if (!params.data) return null;
            return {
              regulation: params.data,
              onUpdate:   this.resetData,
            };
          },
          valueGetter:           ( { data } ) => data,
        },
      ],
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    resetData() {
      this.$refs.table.resetData();
    },
    updateData( page, filters, orderBy ) {
      if (page > 1) return Promise.resolve();
      return this.$http.get('standard_consumption', { params: { buildings_id: this.selectedHouseId } })
        .then(( { data } ) => ({ data, total: data.length }));
    },

    onShowCreate() {
      this.$modal.open({
        size:           'md',
        title:          'Добавление норматива',
        component:      () => import('@/components/calculated-program/regulations/RegulationFormModal'),
        componentProps: {
          onSubmit: ( data ) => {
            return this.$http.post('standard_consumption', {
              ...data,
              buildings_id: this.selectedHouseId,
            });
          },
        },
      }).result.then(this.resetData);
    },
  },
  watch:    {
    selectedHouseId() {
      this.resetData();
    },
  },
};
</script>
